import React, { useState, useMemo, useCallback, useEffect } from 'react';
import Select, { components } from 'react-select';
import cx from 'classnames';
import styles from './index.module.scss.js';

const AccordionSelect = ({ options = [], onSelect, selectedId, className, ...props }) => {
  const [mappedOpt, setMappedOpt] = useState([]);
  const [pos, setPos] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [closeAnim, setCloseAnim] = useState(false);
  const close = () => {
    setCloseAnim(true);
    setTimeout(() => {
      setCloseAnim(false);
      setIsOpen(false);
    }, 400);
  };
  const value = useMemo(() => {
    if (selectedId && options.length) {
      return mappedOpt.find((item) => item.value === selectedId);
    }
    return void 0;
  }, [mappedOpt, selectedId, options]);
  const setTop = useCallback((e) => {
    setPos(e.currentTarget.offsetTop);
  }, []);
  useEffect(() => {
    setMappedOpt(
      options.map((item) => ({
        label: item.name,
        value: item.id,
        icon: item.icon
      }))
    );
  }, [options]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, "accordion-select"),
      style: {
        "--top": `${pos}px`,
        ...props.style
      }
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        className: cx(className, styles["accordion-select"], {
          [styles["close-transition"]]: closeAnim
        }),
        classNamePrefix: "accordion-select",
        isClearable: false,
        isSearchable: false,
        components: {
          IndicatorSeparator: () => null,
          // Control: ({ children, ...props }) => (
          //   <components.Control
          //     {...props}
          //     innerProps={{
          //       ...props.innerProps,
          //       // @ts-ignore
          //       'data-accordion-control': true,
          //       onClick: (e) => {
          //         if (isOpen) return close();
          //         setIsOpen(true);
          //       },
          //     }}
          //   >
          //     {children}
          //   </components.Control>
          // ),
          SingleValue: ({ children, data, ...innerProps }) => {
            const innerValue = data;
            return /* @__PURE__ */ React.createElement(
              components.SingleValue,
              {
                data,
                ...innerProps,
                innerProps: {
                  ...innerProps.innerProps,
                  // @ts-ignore
                  "data-accordion-control": true,
                  onTouchEnd: () => {
                    if (isOpen) {
                      close();
                      return;
                    }
                    setIsOpen(true);
                  },
                  onClick: () => {
                    if (isOpen) {
                      close();
                      return;
                    }
                    setIsOpen(true);
                  }
                }
              },
              innerValue.icon && /* @__PURE__ */ React.createElement("img", { src: innerValue.icon, alt: innerValue.icon }),
              children
            );
          },
          Option: ({ children, data, ...innerProps }) => {
            const innerValue = data;
            const [selected, setSelected] = useState(false);
            useEffect(() => {
              if (innerProps.isSelected) {
                setSelected(true);
                return;
              }
              setTimeout(() => {
                setSelected(innerProps.isFocused || innerProps.isSelected);
              }, 100);
            }, [innerProps.isFocused, innerProps.isSelected]);
            return /* @__PURE__ */ React.createElement(
              components.Option,
              {
                data,
                className: cx({
                  [styles.hovered]: innerProps.isSelected || selected
                }),
                ...innerProps,
                key: innerValue.value
              },
              /* @__PURE__ */ React.createElement("div", { onMouseEnter: setTop }, innerValue.icon && /* @__PURE__ */ React.createElement("img", { src: innerValue.icon, alt: innerValue.icon }), children, /* @__PURE__ */ React.createElement("div", { className: styles.point }, /* @__PURE__ */ React.createElement("div", null), /* @__PURE__ */ React.createElement("div", null)))
            );
          }
        },
        options: mappedOpt,
        value,
        closeMenuOnSelect: false,
        menuIsOpen: isOpen,
        onFocus: () => {
          setIsOpen(true);
        },
        onChange: (v) => {
          onSelect(v.value);
          close();
        }
      }
    )
  );
};
AccordionSelect.displayName = "AccordionSelect";

export { AccordionSelect };
//# sourceMappingURL=index.js.map
